import React, { useState, useEffect } from "react";
import "../Sidebar/css/styles.css";
import { Link, useHistory } from "react-router-dom";
import qs from "qs";
import { userSelector } from "../redux/modules/globalSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  loginUser,
  clearState,
} from "../../components/redux/modules/globalSlice";
import NotificationBell from "./NotificationBell";

export default function Header(props) {
  const history = useHistory();
  const userName = localStorage.getItem("userName");
  const EmpId = localStorage.getItem("EmpId");
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();

  const handleDrawerToggle = () => {
    props.onDrawerToggle();
  };

  const handleLogOut = () => {
    localStorage.clear();
    dispatch(clearState());

    history.push("/login");
  };

  // const { username } = useSelector(userSelector);

  return (
    <div style={{ width: "100%", position: "sticky", top: 0, zIndex: 100 }}>
      {/* Page content wrapper*/}
      <div id="page-content-wrapper">
        {/* Top navigation*/}
        <nav className="navbar navbar-expand-lg navbar-light bg-light border-bottom">
          <div className="container-fluid">
            <span
              className="material-icons-outlined btn"
              id="sidebarToggle"
              onClick={handleDrawerToggle}
            >
              menu
            </span>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <div className="d-flex align-items-center ms-auto mt-2 mt-lg-0">
                <NotificationBell />
                <ul className="navbar-nav ms-3">
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      id="navbarDropdown"
                      href="/"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {userName}
                    </a>
                    <div
                      className="dropdown-menu dropdown-menu-end"
                      aria-labelledby="navbarDropdown"
                    >
                      {/* <a className="dropdown-item" href="#!">
                      Profile
                    </a>
                    <a className="dropdown-item" href="#!">
                      change password
                    </a> */}
                      <div className="dropdown-divider" />
                      <Link to={`/Setting/EditEmployee/${EmpId}`}>
                        <button className="dropdown-item">
                          Profile
                        </button>
                      </Link>
                      <button className="dropdown-item" onClick={handleLogOut}>
                        Log out
                      </button>
                    </div>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}
